import { render } from "./AboutMeComponent.vue?vue&type=template&id=deeec76a&scoped=true"
const script = {}

import "./AboutMeComponent.vue?vue&type=style&index=0&id=deeec76a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-deeec76a"]])

export default __exports__